import Streaming_Activity from "./Streaming Activity";
import Status from "./Status";
import Provider_Share from "./Provider Share";
import Provider_Name from "./Provider Name";
import Provider_Email from "./Provider Email";
import Provider_image from "./Provider image"
import Edit_Email_Consumer_By_Admin from "./Edit Email Consumer By Admin"
import providerEditImage from "./providerEditImage"
import fundSubscriberEditProfile from "./fundSubscriberEditProfile"
const Provider_Permissions_Detail_Dialog={
     Streaming_Activity,
     Status,
     Provider_Share,
     Provider_Name,
     Provider_Email,
     Provider_image,
     Edit_Email_Consumer_By_Admin,
     providerEditImage,
     fundSubscriberEditProfile
}
export default Provider_Permissions_Detail_Dialog;